class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const form = event.target.closest('[data-cart-upsell-form]');
    if (!form) return;

    const button = form.querySelector('button[type="submit"]');
    const buttonText = form.querySelector('[data-cart-upsell-button-text]');
    const spinner = form.querySelector('.loading__spinner');
    const status = form.closest('.cart-upsell__card')?.querySelector('[data-cart-upsell-status]');
    const variantId = form.querySelector('[name="id"]')?.value;
    const isCourse = form.dataset.courseProduct === 'true';
    const cartDrawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');

    if (!variantId || (!cartDrawer && !cartItems) || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    spinner?.classList.remove('hidden');
    if (status) status.textContent = '';

    try {
      const sectionsToRender = cartDrawer ? cartDrawer.getSectionsToRender() : cartItems.getSectionsToRender();
      const sectionIds = [
        ...new Set(sectionsToRender.map((section) => section.section || section.id).filter(Boolean)),
      ];
      const item = { id: Number(variantId), quantity: 1 };
      if (isCourse) {
        item.properties = {
          _course_line_item_id: `course-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
        };
      }

      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body: JSON.stringify({
          items: [item],
          sections: sectionIds,
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || window.cartStrings.error);
      }

      if (buttonText) buttonText.textContent = window.cartStrings.added;
      if (status) status.textContent = isCourse ? window.cartStrings.addedCourse : window.cartStrings.addedItem;
      if (cartDrawer) {
        cartDrawer.renderContents(result);
      } else {
        sectionsToRender.forEach((section) => {
          const sectionRoot = document.getElementById(section.id);
          const target = sectionRoot?.querySelector(section.selector) || sectionRoot;
          const sectionHtml = result.sections?.[section.section];
          if (target && sectionHtml) {
            target.innerHTML = cartItems.getSectionInnerHTML(sectionHtml, section.selector);
          }
        });
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: result, variantId });
    } catch (error) {
      if (status) status.textContent = error.message || window.cartStrings.error;
      button.removeAttribute('aria-busy');
      button.disabled = false;
      spinner?.classList.add('hidden');
    }
  }
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}
